import PropTypes from 'prop-types'

import ModalHeader from './components/PopupHeader/ModalHeader'

/**
 * @param {{
 *   children?: import('react').ReactNode,
 *   isVisible?: boolean,
 *   headerTitle?: string,
 *   headerIcon?: import('react').ReactNode,
 *   headerStyles?: object,
 *   headerClassName?: string,
 *   onClose?: () => void,
 *   closeable?: boolean,
 *   additionalClass?: string,
 *   hideHeader?: boolean,
 *   isResponsive?: boolean,
 * }} props
 */
const ModalContainer = ({
  children,
  isVisible = true,
  headerTitle,
  headerIcon,
  headerStyles = {},
  headerClassName = '',
  onClose = () => {},
  closeable,
  additionalClass = '',
  hideHeader = false,
  isResponsive = false,
}) => {
  if (!isVisible) return null
  return (
    <div className={`modal-container ${additionalClass}`}>
      <div className="overlay" />
      <div className={`modal-container__content ${isResponsive ? 'responsive' : ''}`}>
        {!hideHeader && (
          <ModalHeader
            closeable={closeable}
            onClose={onClose}
            title={headerTitle}
            icon={headerIcon}
            style={headerStyles}
            className={headerClassName}
          />
        )}
        <div className="modal-container-body" style={{ overflow: 'auto' }}>
          {/* change to scroll if something break or add overflow-y */}
          {children}
        </div>
      </div>
    </div>
  )
}

ModalContainer.propTypes = {
  children: PropTypes.node,
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  closeable: PropTypes.bool,
  headerTitle: PropTypes.string,
  headerIcon: PropTypes.node,
  headerStyles: PropTypes.object,
  additionalClass: PropTypes.string,
  hideHeader: PropTypes.bool,
  isResponsive: PropTypes.bool,
  headerClassName: PropTypes.string,
}

export default ModalContainer
